/* SPDX-License-Identifier: Apache-2.0 */
/* SPDX-FileCopyrightText: 2021-2023 OKTET Labs Ltd. */
import {
	RESULT_PROPERTIES,
	RESULT_TYPE,
	RunData,
	MergedRun
} from '@/shared/types';
import { BadgeVariants } from '@/shared/tailwind-ui';

import { ReactNode } from 'react';

/** !!! DO NOT CHANGE !!!
 * This will break URL links
 */
export const enum ColumnId {
	Tree = 'TREE',
	Total = 'TOTAL',
	Run = 'RUN',
	ExpectedTotal = 'EXPECTED_TOTAL',
	UnexpectedTotal = 'UNEXPECTED_TOTAL',
	PassedExpected = 'PASSED_EXPECTED',
	FailedExpected = 'FAILED_EXPECTED',
	PassedUnexpected = 'PASSED_UNEXPECTED',
	FailedUnexpected = 'FAILED_UNEXPECTED',
	SkippedExpected = 'SKIPPED_EXPECTED',
	SkippedUnexpected = 'SKIPPED_UNEXPECTED',
	Abnormal = 'ABNORMAL',
	Objective = 'Objective',
	Comments = 'Notes'
}

export type GlobalFilterValue = {
	/** Row ID */
	rowId: string;
	/** Column ID */
	columnId: ColumnId;
};

export interface RunTableColumnConfig {
	id: ColumnId;
	accessor: (data: RunData | MergedRun) => number | null;
	header: string;
	variant: BadgeVariants;
	resultProperties?: RESULT_PROPERTIES[];
	results: RESULT_TYPE[];
	icon?: ReactNode;
}
